import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import Login from './pages/Login'
import Register from './pages/Register'
import VerifyEmail from './pages/VerifyEmail'
import Dashboard from './pages/Dashboard'
import Game from './pages/Game'
import Combat from './pages/Combat'
import Admin from './pages/Admin'
import Onboarding from './pages/Onboarding'
import BotInventory from './pages/BotInventory'
import CityHub from './pages/CityHub'
import CityShop from './pages/city/CityShop'
import CityWorkshop from './pages/city/CityWorkshop'
import CityHangar from './pages/city/CityHangar'
import CityWarehouse from './pages/city/CityWarehouse'
import CityTransport from './pages/city/CityTransport'
import CityLand from './pages/city/CityLand'
import RpgCity from './pages/RpgCity'
import RpgInterior from './pages/RpgInterior'
import Tutorial from './pages/Tutorial'
import ClanHub from './pages/ClanHub'
import BattleStats from './pages/BattleStats'
import Missions from './pages/Missions'
import LevelUp from './pages/LevelUp'
import Victory from './pages/Victory'
import { ProtectedRoute } from './components/ProtectedRoute'

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Rutas protegidas (requieren autenticación) */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/game" element={<Game />} />
            <Route path="/combat" element={<Combat />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/bot-inventory" element={<BotInventory />} />
            <Route path="/city" element={<CityHub />} />
            <Route path="/city/shop" element={<CityShop />} />
            <Route path="/city/workshop" element={<CityWorkshop />} />
            <Route path="/city/hangar" element={<CityHangar />} />
            <Route path="/city/warehouse" element={<CityWarehouse />} />
            <Route path="/city/transport" element={<CityTransport />} />
            <Route path="/city/land" element={<CityLand />} />
            <Route path="/rpg" element={<RpgCity />} />
            <Route path="/rpg/interior/:sceneKey" element={<RpgInterior />} />
            <Route path="/tutorial" element={<Tutorial />} />
            <Route path="/missions" element={<Missions />} />
            <Route path="/clan" element={<ClanHub />} />
            <Route path="/battle-stats" element={<BattleStats />} />
            <Route path="/victory" element={<Victory />} />
            <Route path="/level-up" element={<LevelUp />} />
          </Route>

          {/* Rutas de admin (requieren autenticación + rol admin) */}
          <Route element={<ProtectedRoute requireAdmin />}>
            <Route path="/admin" element={<Admin />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
